import { createStore, combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import galleries from './reducers/gallery'
import selectedImage from './reducers/selectedImage'
import { composeWithDevTools } from 'redux-devtools-extension'

import initialState from './data/initialState.json'

const store = createStore(
        combineReducers({
            galleries: galleries,
            selectedImage: selectedImage,
            routing: routerReducer
        }),
        initialState,
        composeWithDevTools()
    );

export default store




// WEBPACK FOOTER //
// ./src/store.js